import { render, staticRenderFns } from "./eduList.vue?vue&type=template&id=462e97ab&scoped=true"
import script from "./eduList.vue?vue&type=script&lang=js"
export * from "./eduList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e97ab",
  null
  
)

export default component.exports